import React from 'react'

export default class Banner extends React.Component {
  render() {
    const {
      className,
      text,
      actions,
    } = this.props
    return (
      <div className={`banner-container${className ? ` ${className}` : ``}`}>
        <div className="banner-text">
          { text }
        </div>
        <div className="banner-actions">
          { actions }
        </div>
      </div>
    )
  }
}
